import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Modal, TouchableWithoutFeedback } from 'react-native';
import PlatformIcon from './PlatformIcon';

export interface MapSelectionModalProps {
  visible: boolean;
  onClose: () => void;
  address?: string;
  coords?: { lat: number; lng: number } | null;
}

const MapSelectionModal: React.FC<MapSelectionModalProps> = ({ visible, onClose, address, coords }) => {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlayBottom as any}>
        <TouchableWithoutFeedback onPress={onClose}>
          <View style={styles.backdrop} />
        </TouchableWithoutFeedback>
        <View style={styles.sheetBottom as any}>
        <View style={styles.handleRow}>
          <View style={styles.handle} />
        </View>
        <Text style={styles.title}>选择地图导航</Text>

        <TouchableOpacity
          style={styles.mapOption}
          onPress={() => {
            if (typeof window === 'undefined') return;
            let googleUrl = '';
            if (address && address.trim().length > 0) {
              googleUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`;
            } else if (coords && typeof coords.lat === 'number' && typeof coords.lng === 'number') {
              googleUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${coords.lat},${coords.lng}`)}`;
            }
            if (!googleUrl) return;
            window.open(googleUrl, '_blank');
            onClose();
          }}
        >
          <View style={styles.iconContainer}>
            <img
              src="https://www.google.com/images/branding/product/ico/maps_32dp.ico"
              alt="谷歌地图"
              style={{ width: 32, height: 32, objectFit: 'contain' }}
            />
          </View>
          <View style={{ flex: 1 }}>
            <Text style={styles.optionTitle}>谷歌地图</Text>
            <Text style={styles.optionSubtitle}>在谷歌地图中导航</Text>
          </View>
          <PlatformIcon name="chevron-right" size={20} color="#9CA3AF" family="MaterialIcons" />
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.mapOption}
          onPress={() => {
            if (typeof window === 'undefined') return;
            let gaodeUrl = '';
            if (coords && typeof coords.lat === 'number' && typeof coords.lng === 'number') {
              const name = address ? encodeURIComponent(address) : '';
              gaodeUrl = `https://uri.amap.com/navigation?to=${coords.lng},${coords.lat},${name}&mode=car&policy=0&src=webapp`;
            } else if (address) {
              gaodeUrl = `https://www.amap.com/search?query=${encodeURIComponent(address)}`;
            }
            if (gaodeUrl) {
              window.open(gaodeUrl, '_blank');
              onClose();
            }
          }}
        >
          <View style={styles.iconContainer}>
            <img
              src="https://webapi.amap.com/theme/v1.3/logo@1x.png"
              alt="高德地图"
              style={{ width: 40, height: 40, objectFit: 'contain' }}
            />
          </View>
          <View style={{ flex: 1 }}>
            <Text style={styles.optionTitle}>高德地图</Text>
            <Text style={styles.optionSubtitle}>在高德地图中导航</Text>
          </View>
          <PlatformIcon name="chevron-right" size={20} color="#9CA3AF" family="MaterialIcons" />
        </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlayBottom: {
    flex: 1,
    backgroundColor: 'transparent',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.36)',
  },
  sheetBottom: {
    width: '100%',
    maxWidth: 720,
    backgroundColor: '#fff',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    boxShadow: '0 -12px 40px rgba(0,0,0,0.18)',
    padding: 12,
    boxSizing: 'border-box',
    maxHeight: 'calc(100vh - 64px)',
    marginBottom: 64,
  },
  handleRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
  },
  handle: {
    width: 40,
    height: 4,
    backgroundColor: '#D1D5DB',
    borderRadius: 2,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#111827',
    textAlign: 'center',
    marginBottom: 16,
  },
  mapOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    marginBottom: 12,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  optionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#111827',
  },
  optionSubtitle: {
    fontSize: 13,
    color: '#6B7280',
    marginTop: 2,
  },
});

export default MapSelectionModal;
